import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackViewFilter = ({ element, context, filterLvl, filtersValue, campaignId, }) => {
    const viewFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl !== null && filterLvl !== void 0 ? filterLvl : null,
        filters_value: filtersValue,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-view_filter', {
        event_name: 'view_filter',
        view_filter: viewFilter,
    });
};
